import { memo, useMemo, createContext, type FunctionComponent, type ReactNode } from 'react';
import { RawIntlProvider, type IntlShape } from 'react-intl';
// local imports
import useCustomerSettings from './customer';
import { newIntl } from './intl';

type LocalizationProviderProps = {
  readonly children: ReactNode;
}

// eslint-disable-next-line no-underscore-dangle
window.__REACT_INTL_CONTEXT__ = createContext<IntlShape>(null as unknown as IntlShape);

const LocalizationProvider: FunctionComponent<LocalizationProviderProps> = ({
  children
}) => {
  const { CUSTOM_MESSAGES } = useCustomerSettings();
  const intl = useMemo(() => newIntl(CUSTOM_MESSAGES.en), [CUSTOM_MESSAGES.en]);
  return (
    <RawIntlProvider value={intl}>
      {children}
    </RawIntlProvider>
  );
};

export default memo(LocalizationProvider);
